<template>
  <div class="xcard mt-0 pt-1">
    <v-card class="ins-card elevation-3">
      <v-toolbar flat class="ins-hero">
        <v-btn small class="mr-3" @click="$router.back()" color="white" outlined>
          <v-icon left>mdi-arrow-left-bold</v-icon>
          Volver
        </v-btn>
        <div>
          <div class="text-h6 white--text">Solicitud de pre inscripcion del estudiante</div>
          <div class="text-body-2 white--text">
            Configura el plan, aplica promocion y genera el cronograma de pagos
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="yellow darken-2" class="deep-orange--text text--darken-4" small>
          Paso final
        </v-chip>
      </v-toolbar>

      <v-card-text class="pt-4"> 
        <timelineProgreso ref="reftimelineProgreso"/>

        <v-row dense>
          <v-col cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2">Resumen</div>
              <div class="text-body-2 text--secondary">
                <b>Programa:</b> {{ programa.codigo }} {{ programa.nombre_compuesto }}
              </div>
              <div class="text-body-2 text--secondary">
                <b>Estudiante:</b> {{ $route.query.persona_name }}
              </div>
              <!-- <div class="text-body-2 text--secondary">
                <b>Asesor ID:</b> {{ $route.query.asesor_id }}
              </div> -->
            </v-card>
          </v-col> 
        </v-row>

        <v-row dense>
          <v-col cols="12" md="6">
            <v-select
              v-model="tipo_inscripcion"
              :items="tipos_inscripcion"
              label="Tipo de inscripción"
              dense
              outlined
              clearable
              placeholder="Seleccione el tipo..."
              hide-details
            />
          </v-col>
        </v-row>
        
        <v-row class="justify-center" dense> 
          <v-col v-if="tipo_inscripcion" cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Plan de pagos</div>
              <v-select
                v-model="plan_seleccionado"
                :items="planes_filtrados"
                :loading="loading_programa"
                item-text="nombre"
                item-value="plan_cobro_programa_id"
                label="Seleccione el plan"
                hide-details
                dense
                outlined
                placeholder="Seleccione..."
                return-object
              />

              <div v-if="plan_seleccionado" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Detalle de cobros</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(p, ind) in plan_seleccionado.cobros"
                    :key="ind"
                    class="ma-1"
                    small
                    color="deep-orange lighten-5"
                  >
                    {{ p.nombre }}: Bs. {{ p.monto }} · max {{ p.cuotas }} cuotas
                  </v-chip>
                </v-chip-group>
              </div>

              <div v-if="promo && promo.id && generado && generado.plan_con_descuentos" class="mt-3">
                <div class="text-body-2 text--secondary mb-1">Plan con promocion</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(p, ind) in generado.plan_con_descuentos"
                    :key="ind"
                    class="ma-1"
                    small
                    color="light-blue lighten-5"
                  >
                    {{ p.nombre }}: {{ p.monto }} ({{ p.promo_descuento }})
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col>

          <v-col v-if="tipo_inscripcion" cols="12" md="6">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Promociones ({{ promociones.length }}) </div>
              <v-select
                v-model="promo"
                :items="promociones"
                :loading="loading_promos"
                :disabled="tipo_inscripcion === 'Modular'"
                item-text="nombre"
                item-value="id"
                label="Seleccione la promocion"
                dense
                outlined
                placeholder="Seleccione..."
                clearable
                return-object
              />
              <div v-if="promo && promo.id" class="mt-3">
                <div class="text-body-2">{{ promo.descripcion }}</div>
                <div class="text-body-2 text--secondary">Desde: {{ promo.fecha_inicio }}</div>
                <div class="text-body-2 text--secondary">Hasta: {{ promo.fecha_fin }}</div>
                <div class="text-body-2 text--secondary">Aprobado por: {{ promo.aprobado_por }}</div>
                <v-divider class="my-2"></v-divider>
                <div class="text-body-2 text--secondary mb-1">Beneficios</div>
                <v-chip-group column>
                  <v-chip
                    v-for="(d, ind) in promo.detalle_promocion"
                    :key="ind"
                    class="ma-1"
                    small
                    color="green lighten-5"
                  >
                    {{ d.nombre_concepto }}: {{ d.valor_descuento }} {{ d.is_porcentaje ? '%' : 'Bs.' }}
                  </v-chip>
                </v-chip-group>
              </div>
            </v-card>
          </v-col> 

          <v-col v-if="tipo_inscripcion === 'Modular'" cols="12">
            <v-card outlined class="pa-3">
              <div class="text-subtitle-2 mb-2">Módulos (selección múltiple)</div>
              <v-data-table
                v-model="modulos_seleccionados"
                :headers="headers_modulos"
                :items="modulos"
                :loading="loading_modulos"
                item-key="id"
                show-select
                dense
                hide-default-footer
                :items-per-page="-1"
                no-data-text="Sin módulos disponibles"
              />
            </v-card>
          </v-col>

          <v-col v-if="generado && generado.plan && tipo_inscripcion" cols="12" class="mt-8">
            <v-row dense>
              <v-col cols="12" lg="7">
                <v-card outlined>
                  <v-card-title class="text-subtitle-2">Cronograma de pagos</v-card-title>
                  <v-data-table
                    :headers="headers"
                    :items="plan_cronograma"
                    :items-per-page="150"
                    item-key="index"
                    hide-default-footer
                    class="elevation-1 tabla-pagos"
                    :item-class="rowClass"
                  >
                    <template v-slot:item.monto="{ item }">
                      <span>Bs. {{ item.monto }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>

              <v-col cols="12" lg="5">
                <v-card outlined class="pr-4">
                  <ComprobantePago
                        @comprobante-guardado="handleComprobanteGuardado($event,'comprobantex')"
                      />
                </v-card>
              </v-col>
            </v-row>
          </v-col>

          <v-col v-if="tipo_inscripcion" cols="12" class="d-flex justify-center mt-8 pb-14 mb-10">
            <v-btn
              color="green"
              class="white--text"
              :loading="loading"
              :disabled="plan_cronograma.length === 0 || loading_promos || (tipo_inscripcion === 'Modular' && modulos_seleccionados.length === 0)"
              @click="realizar_ins()"
            >
              <v-icon left>mdi-check-circle</v-icon>
              Solicitar pre inscripcion
            </v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <confirmarModal ref="refconfirmarModal" />
    
  </div>
</template>

<style scoped>
  .ins-card {
    border-radius: 16px;
    overflow: hidden;
  }
  .ins-hero {
    min-height: 90px;
    background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
  }
  ::v-deep .grupo-par {
    background-color: #fcfcfc!important;
  }

  ::v-deep .grupo-impar {
    background-color: #f1f5ff!important;
  }
</style>

<script>
  import { headers, getprograma, getpromociones,getpromocionesv3, generar_plan, rowClassX,realizar_inscripcion_from_preins } from './utils';
  import confirmarModal from './confirmar-modal.vue';
  import ComprobantePago from '@/components/ComprobantePago.vue';
  // import documentoFData from '@/components/documentoFData.vue';
  import timelineProgreso from '../timeline-progreso.vue';
  import { update_prospecto_estado } from '../utils';
import gql from 'graphql-tag';



  export default {
    components: {confirmarModal,ComprobantePago,timelineProgreso},
    data() {
      return {
        loading: false,
        loading_programa: false,
        loading_promos: false,
        loading_modulos: false,
        programa: {},
        plan_seleccionado: null,
        promociones: [],
        promo: {},
        generado: {},
        headers: headers,
        headers_modulos: [
          { text: '#', value: 'numero', width: '60px' },
          { text: 'Nombre', value: 'modulo.nombre' },
        ],
        tipo_inscripcion: null,
        tipos_inscripcion: ['Posgradual', 'Internacional', 'Modular'],
        modulos: [],
        modulos_seleccionados: [],
        comprobanteData: {xbase64:null},
        documentoData: {xbase64:null},
      };
    },
    computed: {
      planes_filtrados() {
        if (!this.programa.planes) return [];
        if (this.tipo_inscripcion === 'Modular') {
          return this.programa.planes.filter(p => p.nombre && p.nombre.toUpperCase().includes('MODULAR'));
        }
        return this.programa.planes;
      },
      plan_cronograma() {
        if (!this.generado || !this.generado.plan) return [];
        if (this.tipo_inscripcion !== 'Modular' || this.modulos_seleccionados.length === 0) {
          return this.generado.plan;
        }
        const n = this.modulos_seleccionados.length;
        const resultado = [];
        this.generado.plan.forEach(item => {
          const [dd, mm, yyyy] = item.fecha_pago.split('/').map(Number);
          for (let i = 0; i < n; i++) {
            const fecha = new Date(yyyy, mm - 1, dd);
            fecha.setMonth(fecha.getMonth() + i);
            const nuevaFecha = `${String(fecha.getDate()).padStart(2,'0')}/${String(fecha.getMonth()+1).padStart(2,'0')}/${fecha.getFullYear()}`;
            resultado.push({ ...item, nro_cuota: i + 1, fecha_pago: nuevaFecha });
          }
        });
        return resultado;
      },
    },
    watch: {
      tipo_inscripcion(val) {
        this.modulos = [];
        this.modulos_seleccionados = [];
        this.plan_seleccionado = null;
        if (val === 'Modular') {
          this.promo = null;
          this.getModulos();
        }
      },
      plan_seleccionado() {
        this.generado = {};
        this.promo = null;
        this.promociones = []
        this.generar_plan_pagos()
        this.getpromos()
      },
      promo() {
        // this.generado = {};
        this.generar_plan_pagos() 
      }
    },
    methods: {
      async getModulos() {
        this.loading_modulos = true;
        const programa_id = this.$route.params.programa_id;
        const qs = gql`query{ getPrograma(id: ${programa_id}) {id programa_modulos{id idmodulo numero modulo{id nombre}}} }`;
        const res = await this.$apollo.query({ query: qs }).then(({ data }) => (data.getPrograma ? data.getPrograma : { programa_modulos: [] }));
        this.modulos = (res.programa_modulos || []).slice().sort((a, b) => a.numero - b.numero);
        this.loading_modulos = false;
      },
      handleComprobanteGuardado(data, tipo) {
        window.console.log("Comprobante guardado:", data);
        if(tipo == 'comprobantex'){
          this.comprobanteData.archivo = data.archivo
          this.comprobanteData.comentario = data.comentario
          this.comprobanteData.fechaPago = data.fechaPago
          this.comprobanteData.monto = data.monto
          this.comprobanteData.depositante = data.depositante
          this.comprobanteData.nrComprobante = data.nrComprobante
          this.comprobanteData.banco = data.banco
          this.comprobanteData.nroCuenta = data.nroCuenta
        }
        else if(tipo == 'documentox'){
          this.documentoData.archivo = data.archivo
          this.documentoData.comentario = data.comentario
          this.documentoData.fechaPago = data.fechaPago
          this.documentoData.monto = data.monto
          this.comprobanteData.depositante = data.depositante
          this.comprobanteData.nrComprobante = data.nrComprobante
          this.comprobanteData.banco = data.banco
          this.comprobanteData.nroCuenta = data.nroCuenta
        }

        if (!data.archivo) {
          window.console.error("Error: No se encontró un archivo en data.archivo");
          return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(data.archivo);
        reader.onload = () => {  // Usamos una arrow function para mantener el contexto de `this`
          if(tipo == 'comprobantex'){
            this.comprobanteData.archivoComprobante = reader.result.split(",")[1];
            this.comprobanteData.xbase64 = reader.result; 

          }else if(tipo == 'documentox') {
            this.documentoData.archivoComprobante = reader.result.split(",")[1];
            this.documentoData.xbase64 = reader.result; 
          }
        };
        reader.onerror = (error) => {
          window.console.error("Error al convertir el archivo a Base64:", error);
        }; 
      }, 
      async getprogramadata() {
        this.loading_programa = true;
        const res = await getprograma(this.$route.params.programa_id);
        this.loading_programa = false;
        if (!res.planes) res.planes = [];
        res.planes.forEach((x) => {
          x.cobros.forEach((c) => {
            if (c.monto == 1) c.monto = 0;
          });
        });
        this.programa = res;
        this.programa.planes = res.planes.filter((x) => x.estado);

      },
      async getpromos() {
        this.loading_promos = true;
        this.promociones = []
        const res = await getpromociones(this.$route.params.programa_id);
        this.loading_promos = false;
        window.console.log('getpromos',res.data);
        
        if (res && res.data) {
          this.promociones.push(...res.data);

          if (res.data.length == 1) this.promo = res.data[0];
        } 
        void this.getpromosv3()
      },
      async getpromosv3() {
        if(!this.plan_seleccionado) return;
        
        this.loading_promos = true;
        const pid = this.$route.params.programa_id
        const res = await getpromocionesv3(pid, this.plan_seleccionado.plan_cobro_programa_id);
        window.console.log('getpromosv3',res.data);
        
        this.loading_promos = false;
        if (res && res.data) {
          res.data.map(x=>{
            x.fecha_inicio = x.fechas[0]?.fecha_inicio
            x.fecha_fin = x.fechas[0]?.fecha_fin
            x.detalle_promocion = []
            x.reglas.forEach(r=>{
              r.conceptos.forEach(c=> x.detalle_promocion.push(c))
            })

          })
          this.promociones.push(...res.data);
          if (res.data.length == 1) this.promo = res.data[0];
        }
      },
      rowClass(item) {
        return rowClassX(item, this.incluir_deuda_q10_in_plan);
      },
      generar_plan_pagos() {
        if(!this.plan_seleccionado) return;
        const cobros = JSON.parse(JSON.stringify(this.plan_seleccionado.cobros));
        const res = generar_plan(this.promo, cobros);
        window.console.log(res);
        this.generado = res; 
      }, 
      async saveEstadoProspecto(estado){
        if(!this.$route.query.prospecto_id) return;

        const dt = {
          prospecto_id: this.$route.query.prospecto_id,
          estado: estado
        }
        await update_prospecto_estado(dt)
      },
      async realizar_ins(){
        if (this.tipo_inscripcion === 'Modular' && this.modulos_seleccionados.length === 0) {
          this.$root.$notify.show('Debe seleccionar al menos un módulo', { color: 'red', x: 'right' });
          return;
        }
        if(!this.comprobanteData || !this.comprobanteData.xbase64){
          this.$root.$notify.show('Debe subir el comprobante de pago', { color: 'red', x: 'right' });
          return;
        }

        const resumen = {
          tipo_inscripcion: this.tipo_inscripcion,
          programa: `${this.programa.codigo || ''} ${this.programa.nombre_compuesto || ''}`.trim(),
          estudiante: this.$route.query.persona_name || '',
          plan: this.plan_seleccionado ? this.plan_seleccionado.nombre : 'No seleccionado',
          promocion: (this.promo && this.promo.id) ? this.promo.nombre : 'Sin promocion',
          plan_pagos: this.plan_cronograma,
          comprobante: !!(this.comprobanteData && (this.comprobanteData.xbase64 || this.comprobanteData.archivoComprobante)),
          documento: !!(this.documentoData && (this.documentoData.xbase64 || this.documentoData.archivoComprobante)),
        };
        const aceptar = await this.$refs.refconfirmarModal.openmodal(resumen);
        if (!aceptar) return;

        const inscrip = {
            asesor_id: parseInt(this.$route.query.asesor_id),
            canal_id: null,
            estudiante_id: parseInt(this.$route.query.persona_id),
            plan_cobro_programa_id: this.plan_seleccionado.plan_cobro_programa_id,
            programa_id: parseInt(this.$route.params.programa_id),
            registrado_por: this.$store.state.DATA_USER.id,
            tipo_pago: true,
            plan_pagos: this.plan_cronograma,
            tipo_inscripcion: this.tipo_inscripcion,
            // observaciones: '',
        }

        // ponemos el id de la promocion
        if(this.promo && this.promo.id) inscrip.promocion_id = this.promo.id;

        if (this.comprobanteData && this.comprobanteData.xbase64){ 
          inscrip.comprobante_pago = {
            "depositante": this.comprobanteData.depositante,
            "nrComprobante": this.comprobanteData.nrComprobante,
            "banco": this.comprobanteData.banco,
            "nroCuenta": this.comprobanteData.nroCuenta,
            "monto": this.comprobanteData.monto,
            "fechaHoraDeposito": this.comprobanteData.fechaPago,
            "comentario": this.comprobanteData.comentario,
            "base64Archivo": this.comprobanteData.xbase64.split(',')[1],
          }
        } 

        this.loading = true; 
        
        inscrip.inscripcion_id = parseInt(this.$route.query.inscripcion_id)
        const res2 = await realizar_inscripcion_from_preins(inscrip);

        if(res2 && res2.error){
          this.$root.$notify.show(res2.error, { color: 'red', x: 'right' });
        }else if(res2 && res2.inscripcion_id){
          this.$root.$notify.show(`inscrito correctamente ID: ${res2.inscripcion_id}`, { color: 'purple', x: 'right' });
          this.loading = false;
          this.$router.back()

        }else{
          window.console.log('res2',res2);
        }

        this.loading = false;
        
      },
      /*async realizar_ins(){
        const resumen = {
          programa: `${this.programa.codigo || ''} ${this.programa.nombre_compuesto || ''}`.trim(),
          estudiante: this.$route.query.persona_name || '',
          plan: this.plan_seleccionado ? this.plan_seleccionado.nombre : 'No seleccionado',
          promocion: (this.promo && this.promo.id) ? this.promo.nombre : 'Sin promocion',
          plan_pagos: (this.generado && this.generado.plan) ? this.generado.plan : [],
          comprobante: !!(this.comprobanteData && (this.comprobanteData.xbase64 || this.comprobanteData.archivoComprobante)),
          documento: !!(this.documentoData && (this.documentoData.xbase64 || this.documentoData.archivoComprobante)),
        };
        const aceptar = await this.$refs.refconfirmarModal.openmodal(resumen);
        if (!aceptar) return;

        const inscrip = {
            asesor_id: parseInt(this.$route.query.asesor_id),
            canal_id: null,
            estudiante_id: parseInt(this.$route.query.persona_id),
            plan_cobro_programa_id: this.plan_seleccionado.plan_cobro_programa_id,
            programa_id: parseInt(this.$route.params.programa_id),
            registrado_por: this.$store.state.DATA_USER.id,
            tipo_pago: true,
            plan_pagos:this.generado.plan, 
            // observaciones: '',
        }
        if(this.promo && this.promo.id) inscrip.promocion_id = this.promo.id;
        
        if (this.comprobanteData && this.comprobanteData.xbase64){
          // inscrip.monto= this.comprobanteData.monto;
          // inscrip.fecha_pago= this.comprobanteData.fechaPago;
          // inscrip.observaciones_pago= this.comprobanteData.comentario;
          // inscrip.comprobante_pago= this.comprobanteData.archivoComprobante;
          inscrip.comprobante_pago = {
            "depositante": this.comprobanteData.depositante,
            "nrComprobante": this.comprobanteData.nrComprobante,
            "banco": this.comprobanteData.banco,
            "nroCuenta": this.comprobanteData.nroCuenta,
            "monto": this.comprobanteData.monto,
            "fechaHoraDeposito": this.comprobanteData.fechaPago,
            "comentario": this.comprobanteData.comentario,
            "base64Archivo": this.comprobanteData.xbase64.split(',')[1],
          }
        }

        this.loading = true;
        await this.save_docs()
        
        const res = await realizar_inscripcion(inscrip) 
        window.console.log('ressss', res);
        
        if(res && res.enrollment_id){
            this.$root.$notify.show(`inscrito correctamente ID: ${res.enrollment_id}`, { color: 'purple', x: 'right' });
            await this.saveEstadoProspecto('INSCRITO')
            this.loading = false;
            this.$router.back()
        }else if(res && res.error){
          if(res.error == 'Error, el estudiante se encuentra en un estado inscrito.'){
            // await this.saveEstadoProspecto('INSCRITO') // no siempre es por el mismo asesor :(
            this.$root.$notify.show(res.error, { color: 'red', x: 'right' });

          }else if(res.error == 'Error, el estudiante se encuentra en un estado preinscrito.'){
            // await this.saveEstadoProspecto('PREINSCRITO')// no siempre es por el mismo asesor :(
            
            inscrip.inscripcion_id = parseInt(this.$route.query.ins_id)
            const res2 = await realizar_inscripcion_from_preins(inscrip);
            
            if(res2 && res2.error){
              this.$root.$notify.show(res2.error, { color: 'red', x: 'right' });
            }else if(res2 && res2.inscripcion_id){
              this.$root.$notify.show(`inscrito correctamente ID: ${res2.inscripcion_id}`, { color: 'purple', x: 'right' });
              this.loading = false;
              this.$router.back()

            }else{
              window.console.log('res2',res2);
            }

          }else{
            this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
          }
          
        }else{
          this.$root.$notify.show('Algo salio mal :(', { color: 'red', x: 'right' });
        }
        this.loading = false;
        
      }*/
    },
    mounted() { 
      this.$nextTick(() => {
        this.$refs.reftimelineProgreso.iniciar(2, false); 
      }); 
      this.getprogramadata();
    },
  };
</script>
